// extracted by mini-css-extract-plugin
export default {"root":"PlasmicNavLink_root__RvV1R","slotTargetChildren":"PlasmicNavLink_slotTargetChildren__4GfdC"};